import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseComponent } from './purchase.component';
import { SharedModule } from 'src/ui/shared/shared.module';
import { PurchaseRoutingModule } from './purchase.routing';
import { DesignComponent } from './design/design.component';
import { AmountComponent } from './amount/amount.component';
import { PaymentComponent } from './payment/payment.component';
import { MessageComponent } from './message/message.component';
import { CommonModule } from '@angular/common';
import { SendComponent } from './send/send.component';
import { CustomComponent } from './custom/custom.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { PurchasePersistenceDataModule } from '../../../data/purchase-persistence/purchase-persistence-data.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    declarations: [
        PurchaseComponent,
        DesignComponent,
        AmountComponent,
        PaymentComponent,
        MessageComponent,
        SendComponent,
        CustomComponent,
        ConfirmationComponent,
    ],
    exports: [
        PurchaseComponent,
        DesignComponent,
        AmountComponent,
        PaymentComponent,
        MessageComponent,
        SendComponent,
        CustomComponent,
        ConfirmationComponent,
    ],
    imports: [
        CommonModule,
        NgbModule,
        SharedModule,
        PurchaseRoutingModule,
        TranslateModule.forChild({
            extend: true,
        }),
        PipesModule,
        PurchasePersistenceDataModule,
        HttpClientModule,
    ],
    providers: [],
    bootstrap: [],
})
export class PurchaseModule {}
